import axios from 'axios';

export default class Popups {
  constructor() {
    this.$element = document.querySelector('.c-popup');

    if (!this.$element) return;

    this.$card = this.$element.querySelector('.c-popup__card');
    this.$cardName = this.$element.querySelector('.c-popup__card-name');
    this.$closeBtn = this.$element.querySelector('.c-popup__close');

    this.subscribers = [];
    this.minWaitTime = 5000;
    this.maxWaitTime = 15000;
    this.visibleClass = 'is-visible';
    this.index = 0;
    this.cancelled = false;

    // Cancel when the close button is clicked
    this.$closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      this.cancelled = true;
      this.$card.classList.remove(this.visibleClass);
    });

    axios
      .get(`${window.site.api.ajax}?action=registered_users`)
      .then(res => this.onSuccess(res));
  }

  /**
   * @function init
   * Cycles through the popups
   */
  init() {
    if (this.cancelled) return;
    if (!this.subscribers.length) return;

    // Create a random delay to show the next popup
    const rand = Math.floor(Math.random() * this.maxWaitTime) + this.minWaitTime;
    let interval = Math.round(rand / 1000) * 1000;

    // Only wait the minimum time on first load
    if (!this.timer) {
      interval = this.minWaitTime;
    }

    this.timer = setTimeout(() => {
      this.update();
      this.init();
    }, interval);
  }

  /**
   * @function update
   * Updates with a random popup
   */
  update() {
    if (this.cancelled) return;

    const subscriber = this.pickItem();
    this.$cardName.innerText = subscriber.first_name;

    // Show the card
    this.$card.classList.add(this.visibleClass);

    // Remove the card after 5 seconds
    const timeout = setTimeout(() => {
      this.$card.classList.remove(this.visibleClass);
      clearTimeout(timeout);
    }, 5000);

    this.index++;
  }

  /**
   * @function pickItem
   * Picks a random subscriber from the list
   */
  pickItem() {
    if (!this.subscribers.length) return;
    // const index = Math.floor(Math.random() * this.subscribers.length);
    if (this.index > this.subscribers.length - 1) {
      this.index = 0;
    }

    return this.subscribers[this.index];
  }

  /**
   * @function onSuccess
   * @param {Object} res
   */
  onSuccess(res) {
    if (res && res.hasOwnProperty('data')) {
      this.subscribers = res.data;
      this.init();
    }
  }
}
